import React from 'react';
import useCurrentUser from '../../hooks/use-current-user';

export const ShowForAdmin = ({ invert, children }) => {
    const { isAdmin } = useCurrentUser();
    return Boolean(isAdmin) !== Boolean(invert) ? (<>{children}</>) : null;
};
